import React from "react";
import Svg from './../Svg';
import guid from "../../helpers/guid";

export default class Shape extends Svg {

    // Note: Commands are case-sensitive.
    // An upper-case command specifies absolute coordinates,
    // MoveTo: M, m
    // LineTo: L, l, H, h, V, v
    // Cubic Bézier Curve: C, c, S, s
    // Quadratic Bézier Curve: Q, q, T, t
    // Elliptical Arc Curve: A, a
    // ClosePath: Z, z
    // while a lower-case command specifies coordinates relative to the current position.
    constructor(id) {
        super();
        if (id === null) {
            this.id = `path-${guid()}`;
        } else {
            this.id = id;
        }
        this.d = [];
        this.r = 0;
    }

    static create(id = null) {
        return new Shape(id);
    }

    /**
     * M x y
     * m dx dy
     */
    moveTo(x, y, absolute = true) {
        this.d.push((absolute ? 'M' : 'm') + ` ${x},${y}`);
        return this;
    }

    /**
     * L x y
     * l dx dy
     */
    lineTo(x, y, absolute = true) {
        this.d.push((absolute ? 'L' : 'l') + ` ${x},${y}`);
        return this;
    }

    /**
     * H x
     * h dx
     */
    lineToHorizontal(x, absolute) {
        this.d.push((absolute ? 'H ' : 'h ') + x);
        return this;
    }

    /**
     * V y
     * v dy
     */
    lineToVertical(y, absolute) {
        this.d.push((absolute ? 'V ' : 'v ') + y);
        return this;
    }

    /**
     *  A rx ry x-axis-rotation large-arc-flag sweep-flag x y
     *  a rx ry x-axis-rotation large-arc-flag sweep-flag dx dy
     */
    arc(rx, ry, xar, laf, sf, x, y, absolute = true) {
        this.d.push((absolute ? 'A' : 'a') + ` ${rx},${ry} ${xar},${laf},${sf} ${x},${y}`);
        return this;
    }

    /**
     * C x1 y1, x2 y2, x y
     * c dx1 dy1, dx2 dy2, dx dy
     */
    cubicBezierCurve(x1, y1, x2, y2, x,y, absolute = true) {
        this.d.push((absolute ? 'C' : 'c') + ` ${x1},${y1} ${x2},${y2} ${x},${y}`);
        return this;
    }

    /**
     * S x2 y2, x y
     * s dx2 dy2, dx dy
     */
    cubicBezierCurveSmooth(x2, y2, x, y, absolute = true) {
        this.d.push((absolute ? 'S' : 's') + ` ${x2},${y2} ${x},${y}`);
        return this;
    }

    /**
     * Q x1 y1, x y
     * q dx1 dy1, dx dy
     */
    quadraticBezierCurve(x1, y1, x, y, absolute = true) {
        this.d.push((absolute ? 'Q' : 'q') + ` ${x1},${y1} ${x},${y}`);
        return this;
    }

    /**
     * T x y
     * t dx dy
     */
    quadraticBezierCurveSmooth(x, y, absolute= true) {
        this.d.push((absolute ? 'T' : 't') + ` ${x},${y}`);
        return this;
    }

    close() {
        this.d.push('Z');
        return this;
    }

    rotation(degrees) {
        this.r = degrees;
        return this;
    }

    buildDAttribute() {
        return this.d.join(' ');
    }

    getId() {
        return this.id;
    }

    draw() {
        this.shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        this.shape.setAttribute('id', this.id);
        this.shape.setAttribute('d', this.buildDAttribute());
        if (this.r !== 0) {
            this.shape.style.transform = `rotate(${this.r}deg)`;
            this.shape.style.transformOrigin = '50% 50%';
        }

        this.style(this.shape);
        return this.shape;
    }

    element() {
        return <path
            id={this.id}
            d={this.buildDAttribute()}
            key={`key-${guid()}`}
            fill={this.fill}
            stroke={this.stroke}
            strokeWidth={this.strokeWidth}
        />
    }
}
